"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Mixins, Ref, Watch } from "vue-property-decorator";
import API from "@ym-framework/api-utils";
import UiDialog, { UiDialogController } from "@/components/dialog/UiDialog.vue";
import UploadEnclosureBottom from "./UploadEnclosureBottom.vue";
import UploadEnclosure from "./UploadEnclosure.vue";
import iconMap from "@/utils/iconMap";
import { Transform } from "@/utils/fileSize";
import DateFormat from "@/framework/timeformatter";
import taskMap from "@/configuration/taskMap";
import { AccountSessionMixins } from "@/service/account-session";
let EnclosureDialog = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.dialog = new UiDialogController();
    this.shopId = "";
    //文件上传组件
    this.uploadedEnclosureList = [];
    // 已上传的附件列表
    this.iconData = iconMap;
    //文件图标数据
    this.taskType = taskMap;
    //任务类型
    this.uploadVDManager = this.$store.state.uploadVDManager;
    //上传任务管理器
    this.uploadSuccess = this.$store.state.uploadVDManager.historyTaskSuccess;
    this.tableLoading = true;
  }
  uploadComplete() {
    if (this.$store.state.uploadVDManager.isUploadSuccessVd) {
      this.tableLoading = true;
      this.$emit("reload", this.uploadVDManager.tmpAuth.id);
      this.clearFileList();
      this.$store.state.uploadVDManager.isUploadSuccessVd = false;
    }
  }
  uploadErrorprompt() {
    if (this.uploadVDManager.errorPrompt === true) {
      this.$message({
        type: "error",
        message: this.$t("main.file_size_exceeds_limit")
      });
      this.uploadVDManager.errorPrompt = false;
    }
  }
  isOverSizePrompt() {
    if (this.uploadVDManager.isOverSize === true) {
      this.$message({
        type: "error",
        message: this.$t("main.space_exceeds_limit")
      });
      this.uploadVDManager.isOverSize = false;
    }
  }
  isMaxSizePrompt() {
    if (this.uploadVDManager.isMaxSize === true) {
      this.$message({
        type: "error",
        message: this.$t("main.file_number_exceeds_limit")
      });
      this.uploadVDManager.isMaxSize = false;
    }
  }
  mounted() {
    window.addEventListener("beforeunload", (e) => {
      if (this.uploadVDManager.queueTask.length >= 1) {
        e.returnValue = "\u786E\u5B9A\u8981\u79BB\u5F00\u5417\uFF1F";
      }
    });
  }
  destroyed() {
    window.removeEventListener("beforeunload", (e) => {
    });
  }
  // 附件列表
  get listOfEnclosure() {
    let uploadedEnclosureList = this.uploadedEnclosureList.map((item) => {
      return {
        keyId: `${Math.random()}${Date.now()}${Math.random()}`,
        file: {
          name: item.name,
          path: item.path,
          size: item.size,
          lastModified: item.updateTime,
          fileId: item.fileUid,
          downloadUrl: item.path
        },
        progress: 100,
        state: this.taskType.success,
        speed: 0,
        path: item.path,
        updateTime: item.updateTime,
        fileType: "upload"
      };
    });
    return this.$store.state.uploadVDManager.queueTask.concat(uploadedEnclosureList);
  }
  open(id) {
    this.shopId = id;
    this.dialog.visible = true;
  }
  // 获取用户可上传的配置信息
  getGrantConfig() {
    return __async(this, null, function* () {
      try {
        let response = yield API.get(
          `api://base.auth.pro/v1/files-space`
        );
        this.uploadVDManager.maxUploadSize = response.data.singleFileMaxSize;
        this.uploadVDManager.maxUploadFileNumber = response.data.usableCount;
        this.uploadVDManager.remainingSpace = response.data.totalFileUsableSize;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  // 取消当前
  cancelCurrentEnclosure(row) {
    this.uploadVDManager.cancelCurrentUpload(row);
  }
  // 打开下载框体
  openUpload() {
    if (this.uploadVDManager.beUpload) {
      this.$message.success(
        this.$t("virtualdesktopform.upload_is_running_tip")
      );
      return;
    }
    this.getGrantConfig();
    this._fileUpload.shopId = this.shopId;
    this._fileUpload.openUpload();
  }
  // 下载全部
  downloadAllEnclosure() {
    if (this.uploadedEnclosureList.length === 0) {
      return;
    }
    for (let index = 0; index < this.uploadedEnclosureList.length; index++) {
      this.downloadEnclosure(this.uploadedEnclosureList[index].downloadUrl);
    }
  }
  save() {
  }
  // 删除全部
  deleteAllEnclosure() {
    return __async(this, null, function* () {
      if (this.listOfEnclosure.length === 0) {
        return;
      }
      this.$confirm(
        this.$t("main.this_action_will_delete_all_attachments"),
        this.$t("main.hint"),
        {
          confirmButtonText: this.$t("main.delete"),
          cancelButtonText: this.$t("main.cancel"),
          type: "warning"
        }
      ).then(() => __async(this, null, function* () {
        this.tableLoading = true;
        for (let index = 0; index < this.uploadedEnclosureList.length; index++) {
          yield API.delete(`api://base.auth/api/v7/goods-files/remote`, {
            data: {
              file_uid: this.uploadedEnclosureList[index].fileUid,
              files: [this.uploadedEnclosureList[index].path]
            }
          });
        }
        this.$emit("reload", "");
        this.$message.success(this.$t("main.delete_successful"));
      }));
    });
  }
  // 下载当前附件
  downloadCurrentEnclosure(item) {
    return __async(this, null, function* () {
      try {
        let res = yield API.get(`api://base.auth.pro/v1/files-download`, {
          params: {
            filePath: item.path
          }
        });
        window.open(res.data.data);
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  // 关闭弹窗 刷新列表
  refresh() {
    this.clearFileList();
    this.uploadVDManager.tmpAuth = void 0;
    this.$emit("refresh");
  }
  // 删除当前附件
  deleteCurrentEnclosure(item) {
    return __async(this, null, function* () {
      this.$confirm(
        this.$t("main.this_action_will_delete_attachments"),
        this.$t("main.hint"),
        {
          confirmButtonText: this.$t("main.delete"),
          cancelButtonText: this.$t("main.cancel"),
          type: "warning"
        }
      ).then(() => __async(this, null, function* () {
        this.tableLoading = true;
        if (item.fileType === "local") {
          yield this.uploadVDManager.removeCurrentTask(item);
        } else {
          yield this.closeModal("uploaded", [item], item.file.fileId);
        }
        this.tableLoading = false;
      }));
    });
  }
  /**
   *  关闭弹窗
   * @param type 上传组件类型
   * @param list  上传组件列表
   * @param fileId  上传组件文件id
   */
  closeModal(type, list, fileId) {
    return __async(this, null, function* () {
      let unUploadList = this.$store.state.uploadVDManager.queueTask.concat(
        this.$store.state.uploadVDManager.historyTaskSuccess
      );
      try {
        let response = yield API.delete(
          `api://base.auth/api/v7/goods-files/remote`,
          {
            data: {
              file_uid: fileId,
              files: type == "uploaded" ? list == null ? void 0 : list.map((item) => item.path) : unUploadList.map((item) => item.path)
            }
          }
        );
        if (type == "uploaded") {
          this.$message.success(this.$t("main.delete_successful"));
          this.$emit("reload", fileId);
        } else {
          this.clearFileList();
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  beforeCloseModal(done) {
    if (this.uploadVDManager.queueTask.length > 0) {
      this.$confirm(
        this.$t("main.attachment_not_saved"),
        this.$t("main.hint"),
        {
          confirmButtonText: this.$t("main.leave"),
          cancelButtonText: this.$t("main.cancel"),
          type: "warning"
        }
      ).then(() => __async(this, null, function* () {
        done();
        this.uploadVDManager.cancelCurrentUpload();
      }));
    } else {
      done();
    }
  }
  // 下载
  downloadEnclosure(url) {
    let a = document.createElement("a");
    a.href = url;
    a.download = "";
    a.click();
  }
  // 清空文件列表
  clearFileList() {
    this.uploadVDManager.clearQueue();
  }
  // 格式化时间
  format_time(time) {
    if (time === 0 || time === null) {
      return "--";
    } else {
      return DateFormat.dateformatterDay(DateFormat.check(time));
    }
  }
  //大小转换
  transform(size) {
    return Transform(size);
  }
};
__decorateClass([
  Ref("fileUpload")
], EnclosureDialog.prototype, "_fileUpload", 2);
__decorateClass([
  Watch("$store.state.uploadVDManager.isUploadSuccessVd")
], EnclosureDialog.prototype, "uploadComplete", 1);
__decorateClass([
  Watch("uploadVDManager.errorPrompt")
], EnclosureDialog.prototype, "uploadErrorprompt", 1);
__decorateClass([
  Watch("uploadVDManager.isOverSize")
], EnclosureDialog.prototype, "isOverSizePrompt", 1);
__decorateClass([
  Watch("uploadVDManager.isMaxSize")
], EnclosureDialog.prototype, "isMaxSizePrompt", 1);
EnclosureDialog = __decorateClass([
  Component({
    components: {
      UiDialog,
      UploadEnclosure,
      UploadEnclosureBottom
    }
  })
], EnclosureDialog);
export {
  EnclosureDialog as default
};
